import { View, Text } from 'react-native'
import React, { useState } from 'react'
import { ThemedView, ThemedText } from '@app/theme'
import FileUpload from '@app/sharedComponents/FileUpload/FileUpload'

const UploadDocumentCard = ({
  isBackSide = false,
  isUploading = false,
  selectedFrontFile,
  setSelectedFrontFile,
  selectedBackFile,
  setSelectedBackFile
}: {
  isBackSide?: boolean,
  isUploading?: boolean,
  selectedFrontFile: any,
  setSelectedFrontFile: (file: any) => void,
  selectedBackFile: any,
  setSelectedBackFile: (file: any) => void
}) => {


  return (
    <ThemedView mt='2xl'>
      <ThemedText variant='h5s'>Upload document</ThemedText>
      <ThemedText mt='2xl' mb='md' variant='b3s'>Front side</ThemedText>
      <FileUpload isUploading={isUploading} maxSize={2} accept={[ ".jpeg", ".png", ".pdf" ,".jpg"]} onFileSelect={setSelectedFrontFile} isFrontSide={true} />

      {/* TODO: back side */}

        {isBackSide && <>
        <ThemedText mt='2xl' mb='md' variant='b3s'>Back side</ThemedText>
        <FileUpload isUploading={isUploading} maxSize={2} accept={[ ".jpeg", ".png", ".pdf" ,".jpg"]} onFileSelect={setSelectedBackFile} />
        </>
        }


    </ThemedView>
  )
}

export default UploadDocumentCard